webpackJsonp([14],{

/***/ 284:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eves_beszamolok_pug__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eves_beszamolok_pug___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__eves_beszamolok_pug__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var MODULE_NAME = 'evesBeszamolok';

var EvesBeszamolokController = function () {
	function EvesBeszamolokController() {
		'ngInject';

		_classCallCheck(this, EvesBeszamolokController);
	}

	EvesBeszamolokController.prototype.$onInit = function $onInit() {
		this.evesBeszamolokLabel = window.evesBeszamolokLabel;
		this.evesBeszamolok = window.evesBeszamolok;
		this.selectedYear = this.evesBeszamolok[0];
	};

	return EvesBeszamolokController;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (angular.module(MODULE_NAME, []).component(MODULE_NAME, {
	controller: EvesBeszamolokController,
	template: __WEBPACK_IMPORTED_MODULE_0__eves_beszamolok_pug___default()(),
	bindings: {}
}).name);

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eves_beszamolok_eves_beszamolok_pcss__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eves_beszamolok_eves_beszamolok_pcss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__eves_beszamolok_eves_beszamolok_pcss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eves_beszamolok_eves_beszamolok_js__ = __webpack_require__(297);



/***/ }),

/***/ 596:
/***/ (function(module, exports, __webpack_require__) {

var pug = __webpack_require__(2);

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv class=\"app-eves-beszamolok\"\u003E\u003Cdiv class=\"row form__row\"\u003E\u003Cdiv class=\"app-eves-beszamolok__label-container\"\u003E\u003Clabel class=\"label label--right label--two-lines\" id=\"eves-beszamolok__ev-label\" for=\"eves-beszamolok__ev\"\u003E{{$ctrl.evesBeszamolokLabel}}:\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"app-eves-beszamolok__select-container\"\u003E\u003Cselect class=\"select\" id=\"eves-beszamolok__ev\" name=\"ev\" ng-options=\"item.year for item in $ctrl.evesBeszamolok\" ng-model=\"$ctrl.selectedYear\"\u003E\u003Coption value=\"\"\u003EKérjük válasszon!\u003C\u002Foption\u003E\u003C\u002Fselect\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"app-eves-beszamolok__documents\"\u003E\u003Cp class=\"app-eves-beszamolok__title\"\u003E{{$ctrl.selectedYear.year}} évi\u003C\u002Fp\u003E\u003Cul class=\"app-eves-beszamolok__list\" role=\"list\"\u003E\u003Cli class=\"app-eves-beszamolok__listitem\" ng-repeat=\"row in $ctrl.selectedYear.data\" role=\"listitem\"\u003E\u003Ca class=\"app-eves-beszamolok__link\" href=\"{{row.documentLink}}\" target=\"_blank\" rel=\"noopener noreferrer\"\u003E{{row.documentName}}\u003C\u002Fa\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;

/***/ })

},[536]);


// WEBPACK FOOTER //
// application/eves-beszamolok.bundle.js